import { v4 as uuidv4 } from 'uuid';
import { ParameterValue } from '../ParametricEngine';

export interface GlobalParameter {
    id: string;
    name: string;
    type: string; // ParameterType
    value: ParameterValue;
    formula?: string; // Can global parameters have formulas? Yes.
}

export class GlobalParameterManager {
    private parameters: Map<string, GlobalParameter> = new Map();
    private listeners: ((paramId: string, newValue: ParameterValue) => void)[] = [];

    constructor() { }

    createParameter(name: string, type: string, value: ParameterValue): GlobalParameter {
        if (this.findByName(name)) {
            throw new Error(`Global parameter '${name}' already exists.`);
        }

        const param: GlobalParameter = {
            id: uuidv4(),
            name,
            type,
            value
        };
        this.parameters.set(param.id, param);
        return param;
    }

    getParameter(id: string): GlobalParameter | undefined {
        return this.parameters.get(id);
    }

    findByName(name: string): GlobalParameter | undefined {
        for (const p of this.parameters.values()) {
            if (p.name === name) return p;
        }
        return undefined;
    }

    setValue(id: string, value: ParameterValue): void {
        const param = this.parameters.get(id);
        if (!param) throw new Error(`Global parameter ${id} not found.`);

        if (param.value !== value) {
            param.value = value;
            this.notifyListeners(id, value);
        }
    }

    getAll(): GlobalParameter[] {
        return Array.from(this.parameters.values());
    }

    // --- Event System ---

    addListener(callback: (paramId: string, val: ParameterValue) => void) {
        this.listeners.push(callback);
    }

    private notifyListeners(id: string, val: ParameterValue) {
        this.listeners.forEach(cb => cb(id, val));
    }
}

export const globalParameterManager = new GlobalParameterManager();
